import styled from "styled-components";

const Wrapper = styled.ul`
  &,
  * {
    font-size: 1em;
    font-weight: 400;
    line-height: 1.4em;
    text-align: left !important;
  }

  margin: 0;
  padding-left: 1.4rem;

  li {
    margin-bottom: 1rem;
  }

  li:last-child {
    margin-bottom: 0;
  }

  strong {
    font-weight: 900;
  }
`;

const NotesList = (props: { children?: any }) => {
  return <Wrapper>{props.children}</Wrapper>;
};

export default NotesList;
